export default import.meta.ROLLDOWN_FILE_URL_ca8kxTHsBppdkximeNw$4g